import { render } from "./AppNotFound.vue?vue&type=template&id=50bc4f68&scoped=true"
import script from "./AppNotFound.vue?vue&type=script&lang=js"
export * from "./AppNotFound.vue?vue&type=script&lang=js"

import "./AppNotFound.vue?vue&type=style&index=0&id=50bc4f68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bc4f68"]])

export default __exports__